import '../custom-xhr'

import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import Root from 'Root'
import 'assets/stylesheets/main.css'
import './locales/i18n'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <StrictMode>
    <Root />
  </StrictMode>
)
